import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../../../components/button";
import Icon from "../../../../components/icon";
import { PencilIcon, PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import IconButton from "../../../../components/icon-button";
import { useActionState, useEffect } from "react";
import toast from "react-hot-toast";
import { deleteShoppingCategory } from "../actions";

export function CreateShoppingCategory() {
  return (
    <Link to="/admin/shopping-category/create">
      <Button className="mt-4">
        Create Shopping Category
        <Icon icon={PlusIcon} label="Create Shopping Category" className="ml-1" />
      </Button>
    </Link>
  );
}

export function UpdateShoppingCategory({ id }: { id: string }) {
  return (
    <Link to={`/admin/shopping-category/edit/${id}`}>
      <IconButton label="Edit" icon={PencilIcon} />
    </Link>
  );
}

export function DeleteShoppingCategory({ id }: { id: string }) {
  const navigate = useNavigate();
  const deleteShoppingCategoryWithId = deleteShoppingCategory.bind(null, id);

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this shopping category?")) {
      e.preventDefault();
    }
  }

  const [state, formAction, isPending] = useActionState(deleteShoppingCategoryWithId, {
    success: false,
    message: undefined as string | undefined,
  });

  useEffect(() => {
    if (state.success) {
      toast.success("Shopping category deleted successfully");
      navigate("/admin/shopping-category?reload=true", { replace: true });
    } else if (state.message) {
      toast.error(state.message);
    }
  }, [state, navigate]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending} />
    </form>
  );
}
